import {Pipe, PipeTransform} from '@angular/core';
import {DataBatchTools} from '@selpia/shared/utils';
import {DataPoint} from '@selpia/shared/models';

@Pipe({standalone: true, name: 'selectValue'})
export class SelectValuePipe implements PipeTransform {
  transform(
    value: DataPoint[],
    measureCode: string | undefined,
    periodCode: string | undefined,
    date: Date | undefined,
  ): number | undefined {
    return DataBatchTools.getDataPointFor(value, {measureCode, periodCode, date})?.value;
  }
}
